import { Box, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useContext, useEffect, useState } from 'react';

import MyUser from './account/MyUser';
import MyHours from './account/MyHours';
import { UserContext } from '../components/UserContex';

const Account = () => {
  const [tab, setTab] = useState('1');
  const user = useContext(UserContext);

  // set tab based on url hash
  useEffect(() => {
    if (window.location.hash.substr(1) === 'user') setTab('1');
    if (window.location.hash.substr(1) === 'hours') setTab('2');
  }, []);

  // set new url hash
  useEffect(() => {
    window.location.hash = { 1: 'user', 2: 'hours' }[tab];
  }, [tab]);

  return (
    <TabContext value={tab}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <TabList onChange={(event, index) => setTab(index)} aria-label="Admin tabs">
          <Tab label="Min bruker" value="1" />
          <Tab label="Mine timer" value="2" />
        </TabList>
      </Box>
      <TabPanel value="1" children={<MyUser />} />
      <TabPanel value="2" children={<MyHours user={user} />} />
    </TabContext>
  );
};

export default Account;
